import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useIntl } from 'react-intl';

// Components
import Heading from '../../../../Heading';
import Subheading from '../../../../Subheading';
import Button from '../../../../Button';

// Assets
import checkMarkImage from '../../assets/check-mark.png';

// Styles
import styles from './Success.styl';

const cx = classNames.bind(styles);

export default function Success(props) {
  const { className, onClick } = props;

  const intl = useIntl();

  const handleClick = () => {
    return onClick();
  };

  return (
    <div className={cx('Success', className)}>
      <img src={checkMarkImage} className={cx('Success__mark')} alt="success" />
      <Heading className={cx('Success__title')} level={2} tagName="h2">
        {intl.formatMessage({ id: 'feedback.successMessage.title' })}
      </Heading>
      <Subheading className={cx('Success__subtitle')}>
        {intl.formatMessage({ id: 'feedback.successMessage.text' })}
      </Subheading>
      <Button onClick={handleClick} secondary>
        {intl.formatMessage({ id: 'feedback.successMessage.button' })}
      </Button>
    </div>
  );
}

Success.defaultProps = {
  className: '',
};

Success.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
